import { Form, Select, Button, DatePicker } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";

import { getButtonDisabled } from "../../../utilities/helpers";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getSummary,
  setOperatorSummary
}) => {
  return (
    <div className="w-fit px-8 py-6">
      <div className="justify-end flex items-center h-full space-x-5 ">
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "company")}
            optionFilterProp="label"
            showSearch
            placeholder="Select Company"
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                templateType: undefined,
                company,
              });

              setConfig({
                ...config,
                templates: get(company, "template_access_list"),
              });
              form.setFieldsValue({
                template: undefined,
              });
              setOperatorSummary(undefined)
            }}
          />
        </Form.Item>
        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              setFilters({
                ...filter,
                templateType: value,
              });
              setOperatorSummary([])
            }}
            
          />
        </Form.Item>

        <Form.Item name="month" initialValue={get(filter, "date")} label="Month" colon={false} layout="vertical">
          <DatePicker
            style={{ minWidth: 250 }}
            format={"MM-YYYY"}
            onChange={(value, dateString) => {
              setFilters({
                ...filter,
                date: value,
              });
            }}
            value={get(filter, "date")}
            picker="month"
          />
        </Form.Item>

        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={getSummary}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default HeaderSelector;
